import { type RoutePointExtendedType } from '../../../utilities/RoutePointsApi';
import type { AssignmentJob } from '../AssignmentJob';

export function sortJobAssignments(
    filteredJobs: AssignmentJob[],
    routePoints: RoutePointExtendedType[]
) {
    let temp = [...filteredJobs];
    temp.sort((a, b) => {
        let aOrderPoint = routePoints.find(
            rp => rp.jobs !== null && rp.jobs.includes(a.getJobId())
        )?.point_order;
        let bOrderPoint = routePoints.find(
            rp => rp.jobs !== null && rp.jobs.includes(b.getJobId())
        )?.point_order;
        if (aOrderPoint && bOrderPoint) {
            return aOrderPoint - bOrderPoint;
        } else if (aOrderPoint) {
            return -1;
        } else if (bOrderPoint) {
            return 1;
        } else {
            return 0;
        }
    });
    return temp;
}
